import { useState, useMemo, useRef } from 'react'
import { FiSearch, FiZap, FiChevronUp, FiChevronDown, FiDownload, FiClock, FiX, FiThumbsUp, FiThumbsDown, FiArrowLeft, FiChevronRight } from 'react-icons/fi'
import api from '../utils/api'
import { useAuth } from '../App'

// Akilli Arama: Turkce serbest soru -> backend kural tabanli ayristirir (LLM yok, ucretsiz) -> tablo + ozet.
// Isletme belirtilmezse firmanin tum isletmeleri (Petrol / Market / Kumpir / Lojistik) ayri tablolarla gelir.
const ORNEKLER = {
  Genel: ['Bu ay borcunu ödemeyenler', 'Bugünkü ciro', 'Bu ayın cirosu geçen aya göre nasıl',
    'En borçlu 20 müşteri', 'Alacak yaşlandırma', 'Bu hafta tahsilat dağılımı'],
  Petrol: ["Altınekin'de bu ay kaç litre mazot satmışız", 'Ladik ile Tatlıcak bu hafta satışları karşılaştır',
    'Tank doluluk', 'Petrol saatlik yoğunluk', 'Petrol bu ay kârlılık'],
  Market: ['Market geçen ay en çok satan 10 ürün', 'Market eksi stoklu ürünler', 'Market bu ay kâr marjı',
    'Market sepet ortalaması bu hafta'],
  Kumpir: ['Kumpir bu ay en çok satan ürünler', 'Kumpir dünkü ciro', 'Kumpir saatlik yoğunluk'],
  Lojistik: ['Lojistikte vadesi geçmiş alacaklar', 'Bu ay plaka bazında sefer sayısı',
    'Lojistik geçen ay gelir gider', 'Şahin Tanker ile bu ay hangi işlemleri yapmışız'],
}
const GECMIS_ANAHTAR = 'akilliArama_gecmis'

const fmtSayi = (v, ondalik = 2) =>
  v == null || v === '' ? '' : Number(v).toLocaleString('tr-TR', { minimumFractionDigits: ondalik, maximumFractionDigits: ondalik })
const fmtTarih = (v) => {
  if (!v) return ''
  const m = String(v).match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}:\d{2}))?/)
  return m ? `${m[3]}.${m[2]}.${m[1]}${m[4] ? ' ' + m[4] : ''}` : String(v)
}
const SAYISAL = ['para', 'litre', 'sayi', 'yuzde']
// Toplanmasi anlamsiz kolonlar (fiyat/ortalama, gun sayilari, yuzdeler)
const toplanmaz = (k) => k.tip === 'yuzde' || /fiyat|gün|ort\.|ortalama|maliyet/i.test(k.ad)

function hucre(v, tip) {
  if (v == null || v === '') return ''
  if (tip === 'para') return fmtSayi(v, 2)
  if (tip === 'litre') return fmtSayi(v, 0)
  if (tip === 'yuzde') return '%' + fmtSayi(v, 1)
  if (tip === 'sayi') return fmtSayi(v, Number.isInteger(Number(v)) ? 0 : 2)
  if (tip === 'tarih') return fmtTarih(v)
  return v
}

const gecmisOku = () => {
  try { return JSON.parse(localStorage.getItem(GECMIS_ANAHTAR) || '[]') } catch (e) { return [] }
}
const gecmisYaz = (liste) => {
  try { localStorage.setItem(GECMIS_ANAHTAR, JSON.stringify(liste.slice(0, 20))) } catch (e) { /* gizli mod */ }
}
const katla = (s) => (s || '').toLocaleLowerCase('tr').normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/ı/g, 'i')

// Tablo satirina tiklama -> backend ara_detay istegi (serbest metin degil, dogrudan isletme+tarih / cari)
const AY_ADLARI = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık']
const isoGun = (d) => d.toISOString().slice(0, 10)
function detayIstegi(d, r) {
  if (d.tip === 'cari') {
    const unvan = r[d.kolon]
    return unvan ? { detay: { tip: 'cari', isletme: d.isletme, unvan }, etiket: `${unvan} — son 3 ay ekstre` } : null
  }
  const v = d.kolon != null ? String(r[d.kolon] ?? '') : ''
  let bas, bit, ad
  if (d.birim === 'sabit') { bas = d.bas; bit = d.bit; ad = d.bas === d.bit ? fmtTarih(d.bas) : `${fmtTarih(d.bas)} – ${fmtTarih(d.bit)}` }
  else if (d.birim === 'ay') {
    const m = v.match(/^(\d{4})-(\d{2})/)
    if (!m) return null
    const y = +m[1], mo = +m[2]
    bas = `${m[1]}-${m[2]}-01`; bit = isoGun(new Date(Date.UTC(y, mo, 0))); ad = `${AY_ADLARI[mo - 1]} ${y}`
  } else if (d.birim === 'hafta') {
    const b = new Date(v.slice(0, 10) + 'T00:00:00Z')
    if (isNaN(b)) return null
    bas = isoGun(b); bit = isoGun(new Date(b.getTime() + 6 * 864e5)); ad = `${fmtTarih(bas)} haftası`
  } else {
    if (!/^\d{4}-\d{2}-\d{2}/.test(v)) return null
    bas = bit = v.slice(0, 10); ad = fmtTarih(bas)
  }
  const istasyon = d.istasyon_kolon != null ? r[d.istasyon_kolon] : null
  const isletmeAd = { petrol: 'Petrol', market: 'Market', kumpir: 'Kumpir', lojistik: 'Lojistik' }[d.isletme] || ''
  return { detay: { tip: 'donem', isletme: d.isletme, bas, bit, istasyon },
    etiket: `${ad} — ${istasyon || isletmeAd} satış detayı`.replace(' —  ', ' — ') }
}

async function excelIndir(tablo) {
  // Mevcut /api/export/xlsx ucu (satirlar kolon basligina gore nesne)
  const data = tablo.satirlar.map(r => Object.fromEntries(tablo.kolonlar.map((k, i) => [k.ad, r[i] ?? ''])))
  try {
    const resp = await fetch('/api/export/xlsx', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('token')}` },
      body: JSON.stringify({ data, filename: tablo.baslik.slice(0, 50), title: tablo.baslik }),
    })
    if (!resp.ok) return
    const url = URL.createObjectURL(await resp.blob())
    const a = document.createElement('a')
    a.href = url
    a.download = `${tablo.baslik.replace(/[\\/:*?"<>|]/g, '_').slice(0, 60)}.xlsx`
    a.click()
    URL.revokeObjectURL(url)
  } catch (e) { console.error('Excel hatasi', e) }
}

function SonucTablosu({ tablo, onDetay }) {
  const [sira, setSira] = useState(null) // {i, yon}
  const satirlar = useMemo(() => {
    if (!sira) return tablo.satirlar
    const sayisal = SAYISAL.includes(tablo.kolonlar[sira.i].tip)
    return [...tablo.satirlar].sort((a, b) => {
      const x = a[sira.i], y = b[sira.i]
      if (x == null) return 1
      if (y == null) return -1
      const r = sayisal ? Number(x) - Number(y) : String(x).localeCompare(String(y), 'tr')
      return sira.yon * r
    })
  }, [tablo, sira])
  const toplamlar = tablo.kolonlar.map((k, i) =>
    tablo.toplam && SAYISAL.includes(k.tip) && !toplanmaz(k)
      ? tablo.satirlar.reduce((s, r) => s + (Number(r[i]) || 0), 0) : null)
  const toplamVar = satirlar.length > 1 && toplamlar.some(t => t != null)

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 mb-4">
      <div className="px-4 py-2.5 border-b border-gray-100 dark:border-gray-700 flex items-center justify-between gap-2">
        <h3 className="font-semibold text-sm text-gray-800 dark:text-gray-100">{tablo.baslik}</h3>
        <div className="flex items-center gap-3 shrink-0">
          {tablo.detay && onDetay && <span className="text-xs text-blue-600 dark:text-blue-300">Satıra tıklayın → detay</span>}
          <span className="text-xs text-gray-500">{tablo.satirlar.length} satır</span>
          {tablo.satirlar.length > 0 && (
            <button onClick={() => excelIndir(tablo)} title="Excel olarak indir"
              className="flex items-center gap-1 text-xs px-2 py-1 rounded bg-green-50 text-green-700 hover:bg-green-100 dark:bg-green-900 dark:text-green-200">
              <FiDownload size={12} /> Excel
            </button>
          )}
        </div>
      </div>
      <div className="overflow-auto" style={{ maxHeight: '60vh' }}>
        <table className="w-full text-sm">
          <thead className="bg-gray-50 dark:bg-gray-900 sticky top-0">
            <tr>
              {tablo.kolonlar.map((k, i) => (
                <th key={i} onClick={() => setSira(s => ({ i, yon: s?.i === i ? -s.yon : (SAYISAL.includes(k.tip) ? -1 : 1) }))}
                  className={`px-3 py-2 font-medium text-gray-600 dark:text-gray-300 cursor-pointer select-none whitespace-nowrap ${SAYISAL.includes(k.tip) ? 'text-right' : 'text-left'}`}>
                  {k.ad}
                  {sira?.i === i && (sira.yon > 0 ? <FiChevronUp className="inline ml-1" /> : <FiChevronDown className="inline ml-1" />)}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {satirlar.map((r, ri) => {
              const ist = tablo.detay && onDetay ? detayIstegi(tablo.detay, r) : null
              return (
              <tr key={ri} onClick={ist ? () => onDetay(ist) : undefined} title={ist ? ist.etiket : undefined}
                className={`border-t border-gray-100 dark:border-gray-700 hover:bg-blue-50 dark:hover:bg-gray-700 ${ist ? 'cursor-pointer' : ''}`}>
                {r.map((v, i) => {
                  const tip = tablo.kolonlar[i].tip
                  const neg = SAYISAL.includes(tip) && Number(v) < 0
                  return (
                    <td key={i} className={`px-3 py-1.5 ${SAYISAL.includes(tip) ? 'text-right tabular-nums whitespace-nowrap' : ''} ${neg ? 'text-red-600' : 'text-gray-800 dark:text-gray-200'} ${ist && i === (tablo.detay.kolon ?? tablo.detay.istasyon_kolon) ? 'text-blue-700 dark:text-blue-300 underline decoration-dotted' : ''}`}>
                      {hucre(v, tip)}
                      {ist && i === r.length - 1 && <FiChevronRight className="inline ml-1 text-gray-400" size={12} />}
                    </td>
                  )
                })}
              </tr>
              )
            })}
          </tbody>
          {toplamVar && (
            <tfoot className="bg-gray-100 dark:bg-gray-900 font-semibold sticky bottom-0">
              <tr>
                {tablo.kolonlar.map((k, i) => (
                  <td key={i} className={`px-3 py-2 ${SAYISAL.includes(k.tip) ? 'text-right tabular-nums whitespace-nowrap' : ''} text-gray-800 dark:text-gray-100`}>
                    {i === 0 ? 'TOPLAM' : (toplamlar[i] != null ? hucre(toplamlar[i], k.tip) : '')}
                  </td>
                ))}
              </tr>
            </tfoot>
          )}
        </table>
      </div>
    </div>
  )
}

function Cip({ renk, children }) {
  const r = {
    mavi: 'bg-blue-50 text-blue-700 dark:bg-blue-900 dark:text-blue-200',
    yesil: 'bg-green-50 text-green-700 dark:bg-green-900 dark:text-green-200',
    mor: 'bg-purple-50 text-purple-700 dark:bg-purple-900 dark:text-purple-200',
    turuncu: 'bg-orange-50 text-orange-700 dark:bg-orange-900 dark:text-orange-200',
  }[renk]
  return <span className={`px-2 py-1 rounded-md ${r}`}>{children}</span>
}

function GeriBildirim({ logId, yardim }) {
  // Her soru loglaniyor; kullanici "ise yaramadi" derse ne aradigini yazar -> admin Arama Kayitlari sayfasinda gorur
  const [puan, setPuan] = useState(null)
  const [yorum, setYorum] = useState('')
  const [gonderildi, setGonderildi] = useState(false)
  if (!logId) return null
  const gonder = async (p, y) => {
    setPuan(p)
    try { await api.post(`/akilli-arama/${logId}/geri-bildirim`, { puan: p, yorum: y || null }) } catch (e) { /* sessiz */ }
    if (p === 1 || y) setGonderildi(true)
  }
  if (gonderildi) return <div className="text-xs text-green-600 mb-4">Teşekkürler, geri bildiriminiz kaydedildi.</div>
  if (puan === -1 || yardim) return (
    <form onSubmit={(e) => { e.preventDefault(); gonder(-1, yorum.trim()) }}
      className="flex flex-wrap items-center gap-2 mb-4 p-3 rounded-xl bg-orange-50 dark:bg-gray-800 border border-orange-100 dark:border-gray-700 text-sm">
      <span className="text-gray-700 dark:text-gray-200">Ne arıyordunuz? Yazın, bir sonraki güncellemede ekleyelim:</span>
      <input value={yorum} onChange={(e) => setYorum(e.target.value)} maxLength={500} autoFocus={!yardim}
        placeholder="Örn: Şoför bazında yakıt tüketimi görmek istiyordum"
        className="flex-1 min-w-[220px] px-3 py-1.5 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-900 dark:text-gray-100" />
      <button type="submit" disabled={!yorum.trim()}
        className="px-3 py-1.5 bg-orange-500 hover:bg-orange-600 disabled:opacity-50 text-white rounded-lg">Gönder</button>
    </form>
  )
  return (
    <div className="flex items-center gap-2 mb-4 text-xs text-gray-500">
      <span>Sonuç işinize yaradı mı?</span>
      <button onClick={() => gonder(1)} className="flex items-center gap-1 px-2 py-1 rounded hover:bg-green-50 hover:text-green-700"><FiThumbsUp /> Evet</button>
      <button onClick={() => setPuan(-1)} className="flex items-center gap-1 px-2 py-1 rounded hover:bg-orange-50 hover:text-orange-700"><FiThumbsDown /> Aradığım bu değil</button>
    </div>
  )
}

export default function AkilliArama() {
  const { selectedCompanyId } = useAuth()
  const [soru, setSoru] = useState('')
  const [yukleniyor, setYukleniyor] = useState(false)
  const [sonuc, setSonuc] = useState(null)
  const [hata, setHata] = useState('')
  const [gecmis, setGecmis] = useState(gecmisOku)
  const [oneriAcik, setOneriAcik] = useState(false)
  const [yigin, setYigin] = useState([]) // detaya inince onceki sonuclar (Geri icin)
  const [detayEtiket, setDetayEtiket] = useState('')
  const inputRef = useRef(null)

  // Yazarken oneri: son sorular + ornekler icinden eslesenler
  const oneriler = useMemo(() => {
    const q = katla(soru.trim())
    const tum = [...gecmis.map(s => ({ s, gecmis: true })),
      ...Object.values(ORNEKLER).flat().filter(s => !gecmis.includes(s)).map(s => ({ s, gecmis: false }))]
    if (!q) return tum.filter(x => x.gecmis).slice(0, 8)
    const kel = q.split(/\s+/)
    return tum.filter(x => kel.every(k => katla(x.s).includes(k)) && katla(x.s) !== q).slice(0, 8)
  }, [soru, gecmis])

  const sor = async (metin) => {
    const q = (metin ?? soru).trim()
    if (!q) return
    setSoru(q); setYukleniyor(true); setHata(''); setOneriAcik(false); setYigin([]); setDetayEtiket('')
    try {
      const { data } = await api.post('/akilli-arama', { soru: q, company_id: selectedCompanyId })
      setSonuc(data)
      if (data.niyet !== 'yardim') {
        const yeni = [q, ...gecmis.filter(s => s !== q)].slice(0, 20)
        setGecmis(yeni); gecmisYaz(yeni)
      }
    } catch (e) {
      setHata(e.response?.data?.detail || 'Soru yanıtlanamadı')
      setSonuc(null)
    }
    setYukleniyor(false)
  }

  const detayAc = async ({ detay, etiket }) => {
    setYigin(y => [...y, { sonuc, detayEtiket }])
    setYukleniyor(true); setHata('')
    try {
      const { data } = await api.post('/akilli-arama', { soru: `↳ ${etiket}`, detay, company_id: selectedCompanyId })
      setSonuc(data); setDetayEtiket(etiket)
      window.scrollTo({ top: 0, behavior: 'smooth' })
    } catch (e) {
      setHata(e.response?.data?.detail || 'Detay açılamadı')
      setYigin(y => y.slice(0, -1))
    }
    setYukleniyor(false)
  }
  const geri = () => {
    const onceki = yigin[yigin.length - 1]
    if (!onceki) return
    setSonuc(onceki.sonuc); setDetayEtiket(onceki.detayEtiket); setYigin(y => y.slice(0, -1)); setHata('')
  }

  const gecmisSil = (s) => {
    const yeni = gecmis.filter(x => x !== s)
    setGecmis(yeni); gecmisYaz(yeni)
  }

  const anl = sonuc?.anlasilan || {}
  const ornekler = sonuc?.ornekler || ORNEKLER

  return (
    <div className="p-4 md:p-6 max-w-7xl mx-auto">
      <div className="flex items-center gap-2 mb-1">
        <FiZap className="text-blue-600" size={22} />
        <h1 className="text-xl font-bold text-gray-800 dark:text-gray-100">Akıllı Arama</h1>
      </div>
      <p className="text-sm text-gray-500 dark:text-gray-400 mb-4">
        Günlük dille sorun: ciro, tahsilat, borç/alacak, vade, kâr, stok, sefer… İşletme yazmazsanız (petrol, market,
        kumpir, lojistik) hepsine birden bakılır. Dönem: bugün, dün, bu/geçen hafta, bu/geçen ay, Eylül 2026, ocak-mart,
        ilk çeyrek, son 30 gün…
      </p>

      <form onSubmit={(e) => { e.preventDefault(); sor() }} className="flex gap-2 mb-3">
        <div className="relative flex-1">
          <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
          <input ref={inputRef} value={soru} maxLength={300} autoFocus
            onChange={(e) => { setSoru(e.target.value); setOneriAcik(true) }}
            onFocus={() => setOneriAcik(true)} onBlur={() => setTimeout(() => setOneriAcik(false), 150)}
            onKeyDown={(e) => { if (e.key === 'Escape') setOneriAcik(false) }}
            placeholder="Örn: Bu ay borcunu ödemeyenler"
            className="w-full pl-10 pr-3 py-3 border border-gray-300 dark:border-gray-600 rounded-xl text-sm bg-white dark:bg-gray-800 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500" />
          {oneriAcik && oneriler.length > 0 && (
            <div className="absolute z-20 left-0 right-0 mt-1 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl shadow-lg overflow-hidden">
              {oneriler.map(({ s, gecmis: g }) => (
                <div key={s} className="flex items-center hover:bg-blue-50 dark:hover:bg-gray-700">
                  <button type="button" onMouseDown={(e) => { e.preventDefault(); sor(s) }}
                    className="flex-1 flex items-center gap-2 text-left px-3 py-2 text-sm text-gray-700 dark:text-gray-200">
                    {g ? <FiClock className="text-gray-400 shrink-0" size={13} /> : <FiSearch className="text-gray-300 shrink-0" size={13} />}
                    {s}
                  </button>
                  {g && (
                    <button type="button" title="Geçmişten sil" onMouseDown={(e) => { e.preventDefault(); gecmisSil(s) }}
                      className="px-3 text-gray-300 hover:text-red-500"><FiX size={13} /></button>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
        <button type="submit" disabled={yukleniyor}
          className="px-5 py-3 bg-blue-600 hover:bg-blue-700 disabled:opacity-60 text-white rounded-xl text-sm font-medium">
          {yukleniyor ? 'Aranıyor…' : 'Sor'}
        </button>
      </form>

      {(!sonuc || sonuc.niyet === 'yardim') && (
        <div className="grid gap-3 mb-5" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))' }}>
          {Object.entries(ornekler).map(([grup, liste]) => (
            <div key={grup} className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl p-3">
              <div className="text-xs font-semibold text-gray-500 dark:text-gray-400 mb-2">{grup}</div>
              <div className="flex flex-wrap gap-1.5">
                {liste.map((o) => (
                  <button key={o} onClick={() => sor(o)}
                    className="px-2.5 py-1 text-xs rounded-full bg-gray-100 hover:bg-blue-100 dark:bg-gray-700 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-200 text-left">
                    {o}
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}

      {hata && <div className="p-3 mb-4 rounded-lg bg-red-50 text-red-700 text-sm">{hata}</div>}

      {sonuc && (
        <>
          {yigin.length > 0 && (
            <div className="flex flex-wrap items-center gap-2 mb-3">
              <button onClick={geri} disabled={yukleniyor}
                className="flex items-center gap-1 px-3 py-1.5 text-sm rounded-lg bg-gray-100 hover:bg-gray-200 dark:bg-gray-700 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-200">
                <FiArrowLeft /> Geri
              </button>
              <span className="text-sm font-semibold text-gray-800 dark:text-gray-100">{detayEtiket}</span>
              {yukleniyor && <span className="text-xs text-gray-400">yükleniyor…</span>}
            </div>
          )}
          {sonuc.niyet !== 'yardim' && (
            <div className="flex flex-wrap items-center gap-2 mb-3 text-xs">
              <span className="text-gray-500">Anladığım:</span>
              {anl.niyet && <Cip renk="mor">{anl.niyet}</Cip>}
              {anl.isletme?.map(i => <Cip key={i} renk="yesil">{i}</Cip>)}
              {anl.donem && <Cip renk="mavi">{anl.donem}</Cip>}
              {anl.istasyon && <Cip renk="turuncu">İstasyon: {anl.istasyon.join(', ')}</Cip>}
              {anl.urun && <Cip renk="turuncu">Ürün: {anl.urun}</Cip>}
              {anl.tasima && <Cip renk="turuncu">{anl.tasima}</Cip>}
              {anl.limit && <Cip renk="turuncu">İlk {anl.limit}</Cip>}
              {anl.cari && <Cip renk="turuncu">Cari: {anl.cari.slice(0, 4).join(' · ')}{anl.cari.length > 4 ? ' …' : ''}</Cip>}
              <button onClick={() => { setSonuc(null); setSoru(''); inputRef.current?.focus() }}
                className="ml-auto text-gray-400 hover:text-gray-600">Örnek sorular</button>
            </div>
          )}
          <div className="p-4 mb-4 rounded-xl bg-blue-50 dark:bg-gray-800 border border-blue-100 dark:border-gray-700 text-sm text-gray-800 dark:text-gray-100">
            {sonuc.ozet.split(' · ').map((p, i) => <div key={i} className={i ? 'mt-1' : ''}>{p}</div>)}
          </div>
          <GeriBildirim key={sonuc.log_id} logId={sonuc.log_id} yardim={sonuc.niyet === 'yardim'} />
          {sonuc.tablolar?.map((t, i) => <SonucTablosu key={`${sonuc.ozet}-${i}`} tablo={t} onDetay={yukleniyor ? null : detayAc} />)}
        </>
      )}
    </div>
  )
}
